module.exports = __webpack_public_path__ + "static/media/UCDavis_white.fdc41358.png";